import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-unauthenticated',
	templateUrl: './unauthenticated.component.html',
	styleUrls: ['./unauthenticated.component.scss']
})
export class UnauthenticatedComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}
